// extracted by mini-css-extract-plugin
module.exports = {"address":"a10a3f92e9--address--SMU25"};